import ImigrationReportIndex from "@/views/report/imigration/ImigrationReportIndex.vue";

const imigrationReport = [
  {
    path: "/imigration-report",
    name: "imigration-report",
    component: ImigrationReportIndex,
    meta: {
      layout: "default",
      role: ["superadmin"],
      public: false,
    },
  },
];

export default imigrationReport;
